import { fetchLessonClassGroupMeeting } from "classroom/api/teacher";
import type { GroupMeeting } from "meetings/group-meeting/types";
import { defineStore } from "pinia";

export const useClassroomLessonClassGroupMeetingStore = defineStore(
  "classroomLessonClassGroupMeeting",
  () => {
    const loadGroupMeeting = async (
      scheduleId: string,
      signal?: AbortSignal,
    ): Promise<GroupMeeting> => {
      return fetchLessonClassGroupMeeting(scheduleId, signal);
    };

    return { loadGroupMeeting };
  },
);
